export function dockSuggestions(pathname: string): string[] {
  if (pathname.startsWith('/my-commissions')) {
    return ['Combien j’ai gagné ce mois ?', 'Crée une commission de 10 DH sur Confirmé'];
  }
  if (pathname.startsWith('/dashboard')) {
    return ['Combien de livrées aujourd’hui ?', 'Épingle la recherche Relances'];
  }
  if (pathname.startsWith('/admin')) {
    return ['Où sont les recherches enregistrées ?', 'Crée un produit Tshirt à 199'];
  }
  if (pathname.startsWith('/clients')) {
    return ['Comment créer un client ?', 'Nouveau client 0641000000 Sara'];
  }
  return ['Combien de livrées aujourd’hui ?', 'Livrées aujourd’hui', 'Que peux-tu faire ?'];
}

export function suggestionIcon(text: string): string {
  const t = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  if (t.includes('stock') || t.includes('produit')) return 'package';
  if (t.includes('graphique')) return 'chart';
  if (t.includes('client')) return 'user';
  if (t.includes('commande')) return 'shopping-cart';
  if (t.includes('recherche') || t.includes('epingle') || t.startsWith('ouvre') || t.startsWith('ou ')) return 'search';
  if (t.includes('comment') || t.includes('peux')) return 'help-circle';
  if (t.includes('commission') || t.includes('gagne') || t.includes('livre')) return 'truck';
  if (t.includes('combien') || t.includes('moyenne')) return 'chart';
  if (t.includes('cree') || t.includes('ajoute') || t.includes('nouveau')) return 'plus';
  return 'sparkles';
}
